<div class="cm__page-not-found" style="display: block">
  <div class="cm__container is-4060 is-adjacent">
    <div class="cm__container__col">
      <div class="cm__rte">
        <div class="content-panel__eyebrow">404 error - page not found</div>
        <h1 class="header header--1">Sorry, we can’t find that page.</h1>
      </div>
    </div>
    <div class="cm__container__col">
      <div class="cm__rte">
        <img
          alt=""
          src="/assets/images/Horizon-Consumer-Category-header-large.png"
          class="initial loading"
          data-was-processed="true"
        />
      </div>
    </div>
  </div>
</div>
